import React from 'react';

import Layout from './components/Layout';
import GlobalStyles from './styles/GlobalStykes';
function App() {
  return (
    <>
      <Layout />
      <GlobalStyles/>
    </> 
  );
}

export default App;
